import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a914c28"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "trade_buttons" };
import { useMessage } from '@/const/messages';
import Button from '@/materials/atoms/Button.vue';
import { useSound } from '@/logics/sound';
export default /*#__PURE__*/ _defineComponent({
    emits: ["click"],
    setup(__props, { emit }) {
        const { closeClear, play } = useSound();
        const { format, ORDER } = useMessage();
        const onClick = () => {
            play(closeClear);
            emit('click');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Button, {
                    width: "100%",
                    height: "24px",
                    class: "button",
                    innerText: _unref(format)(_unref(ORDER).CLEAR),
                    colorMode: "clear",
                    fontSize: 13,
                    onClick: onClick
                }, null, 8, ["innerText"])
            ]));
        };
    }
});
